
export class JsonChange {
    propertyName: string;
    previousValue: string;
    currentValue: string;

    constructor(name: string, previousValue: string, currentValue: string) {
        this.propertyName = name;
        this.previousValue = previousValue ?? 'undefined';
        this.currentValue = currentValue ?? 'undefined';
    }
}
